import React from 'react'

import styles from './NoReferrals.module.scss'

const NoReferrals = () => {
  return (
    <div className={styles.wrapper}>
      <p className={styles.title}>Реферали відсутні</p>
      <p className={styles.subtitle}>але це можна швидко виправити скориставшись кнопкою нище :)</p>
    </div>
  )
}

export default NoReferrals
